module.exports = __webpack_public_path__ + "static/media/introduce.8874c7fd.svg";